/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HotelBookingUpdateRequest
 */
export interface HotelBookingUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelBookingUpdateRequest
     */
    confirmationNumber?: string;
    /**
     * Identifies confirmation updates derived from parsed email rather than booking completion.
     * @type {string}
     * @memberof HotelBookingUpdateRequest
     */
    confirmationSource?: HotelBookingUpdateRequestConfirmationSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof HotelBookingUpdateRequest
     */
    cancellationSource?: HotelBookingUpdateRequestCancellationSourceEnum;
    /**
     * Cancellation datetime, which is not null only when cancellation_source is not null.
     * @type {Date}
     * @memberof HotelBookingUpdateRequest
     */
    cancelledAt?: Date;
    /**
     * Support operator (Gondola user id) hand-completing this reservation; recorded on the booking so an operator can review what they've booked. Only honored on manual completion.
     * @type {string}
     * @memberof HotelBookingUpdateRequest
     */
    manualBookerUserId?: string | null;
    /**
     * Set when a reservation scrape shows the stay was changed at the hotel (dates or occupancy) after booking. Only true is honored; the flag is never cleared.
     * @type {boolean}
     * @memberof HotelBookingUpdateRequest
     */
    externallyModified?: boolean;
}


/**
 * @export
 */
export const HotelBookingUpdateRequestConfirmationSourceEnum = {
    EmailParser: 'email_parser'
} as const;
export type HotelBookingUpdateRequestConfirmationSourceEnum = typeof HotelBookingUpdateRequestConfirmationSourceEnum[keyof typeof HotelBookingUpdateRequestConfirmationSourceEnum];

/**
 * @export
 */
export const HotelBookingUpdateRequestCancellationSourceEnum = {
    Email: 'email',
    User: 'user',
    AutoSaveFailure: 'auto_save_failure'
} as const;
export type HotelBookingUpdateRequestCancellationSourceEnum = typeof HotelBookingUpdateRequestCancellationSourceEnum[keyof typeof HotelBookingUpdateRequestCancellationSourceEnum];


/**
 * Check if a given object implements the HotelBookingUpdateRequest interface.
 */
export function instanceOfHotelBookingUpdateRequest(value: object): value is HotelBookingUpdateRequest {
    return true;
}

export function HotelBookingUpdateRequestFromJSON(json: any): HotelBookingUpdateRequest {
    return HotelBookingUpdateRequestFromJSONTyped(json, false);
}

export function HotelBookingUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelBookingUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'confirmationNumber': json['confirmation_number'] == null ? undefined : json['confirmation_number'],
        'confirmationSource': json['confirmation_source'] == null ? undefined : json['confirmation_source'],
        'cancellationSource': json['cancellation_source'] == null ? undefined : json['cancellation_source'],
        'cancelledAt': json['cancelled_at'] == null ? undefined : (new Date(json['cancelled_at'])),
        'manualBookerUserId': json['manual_booker_user_id'] == null ? undefined : json['manual_booker_user_id'],
        'externallyModified': json['externally_modified'] == null ? undefined : json['externally_modified'],
    };
}

export function HotelBookingUpdateRequestToJSON(json: any): HotelBookingUpdateRequest {
    return HotelBookingUpdateRequestToJSONTyped(json, false);
}

export function HotelBookingUpdateRequestToJSONTyped(value?: HotelBookingUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'confirmation_number': value['confirmationNumber'],
        'confirmation_source': value['confirmationSource'],
        'cancellation_source': value['cancellationSource'],
        'cancelled_at': value['cancelledAt'] == null ? value['cancelledAt'] : value['cancelledAt'].toISOString(),
        'manual_booker_user_id': value['manualBookerUserId'],
        'externally_modified': value['externallyModified'],
    };
}

